import { render, staticRenderFns } from "./SelectDevicesModal.vue?vue&type=template&id=045d8852"
import script from "./SelectDevicesModal.vue?vue&type=script&lang=js"
export * from "./SelectDevicesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports